import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Zoom } from '@mui/material';

export default function CustomAddModal(props) {
    const { handleClose, title, onSubmitConfirm, open, saveLabel = 'Add', maxWidth = "sm", disableOutClick = false, disableSave = false } = props;
    return (
        <div>
            <Dialog
                open={open}
                fullWidth
                maxWidth={maxWidth}
                TransitionComponent={Zoom}
                onClose={disableOutClick ? () => { } : handleClose}
            >
                <DialogTitle id="alert-dialog-title" className="font-family">{title}</DialogTitle>
                <DialogContent>
                    {props.children}
                </DialogContent>
                <DialogActions>
                    {disableSave ? null : <Button onClick={onSubmitConfirm} color="primary" variant="outlined" className="font-family">
                        {saveLabel}
                    </Button>}
                    <Button onClick={handleClose} color="secondary" variant="outlined" className="font-family" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}